import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { feedbackAPI } from "../api/endpoints";
import { toast } from "react-toastify";

export default function Feedback() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await feedbackAPI.submit(subject, message, email);
      toast.success("Thank you for your feedback!");
      // Navigate back to the previous page after a short delay so the toast is visible
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to submit feedback");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      <div className="max-w-2xl mx-auto px-5 md:px-10">
        <h1 className="text-2xl font-bold text-white mb-2">Feedback</h1>
        <p className="text-gray-500 text-sm mb-8">We'd love to hear from you. Share your thoughts to help us improve.</p>

        <form onSubmit={handleSubmit} className="bg-dark-700 border border-dark-400 rounded-2xl p-6 md:p-8 space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1.5">Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required placeholder="Your name"
                className="w-full px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-white text-sm placeholder:text-gray-600 focus:border-primary outline-none transition-all" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@example.com"
                className="w-full px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-white text-sm placeholder:text-gray-600 focus:border-primary outline-none transition-all" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1.5">Subject</label>
            <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} required placeholder="What's this about?"
              className="w-full px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-white text-sm placeholder:text-gray-600 focus:border-primary outline-none transition-all" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1.5">Message</label>
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} required rows={5} placeholder="Your feedback..."
              className="w-full px-4 py-3 bg-dark-600 border border-dark-400 rounded-lg text-white text-sm placeholder:text-gray-600 focus:border-primary outline-none transition-all resize-none" />
          </div>
          <button type="submit" disabled={loading}
            className="btn-play-gradient disabled:opacity-50">
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>
        </form>
      </div>
    </div>
  );
}
